import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CustomSnackBarComponent } from './custom-snack-bar/custom-snack-bar.component';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CheckHeightPipe } from '../pipes/check-height-div';
import { NameFilePipe } from '../pipes/name-file.pipe';
import { CheckOptionDisabledTeacherSubjectLevelPipe } from '../pipes/check-option-disabled-teacher-subject-level.pipe';
import { CheckStudyLessonTeacherIsLanguagePipe } from '../pipes/check-study-lesson-teacher-is-language.pipe';
import { VarDirective } from '../directives/var/ng-var.directive';
import { ErrorImageDirective } from '../directives/error-image/error-image.directive';
import { LazyLoadDirective } from '../directives/lazy-load/lazy-load.directive';
import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid';
import { RouterModule } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SidenavComponent } from './sidenav/sidenav.component';
import { LoadingComponent } from './loading/loading.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Autocomplete2Component } from './autocomplete2/autocomplete2.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BookingCalendarComponent } from './booking-calendar/booking-calendar.component';
import { SelectFilterableComponent } from './select-filterable/select-filterable.component';
import { AgendaDialogComponent } from './agenda-dialog/agenda-dialog.component';
import { JitsiComponent } from './jitsi/jitsi.component';
import { PaymentDialogComponent } from './payment-dialog/payment-dialog.component';
import { BookingDialogComponent } from './booking-dialog/booking-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { TeacherImageAdvicesDialogComponent } from './teacher-image-advices-dialog/teacher-image-advices-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { checkUserCanConfirmClassPipe } from '../pipes/check-user-can-confirm-class.pipe';
import { DomSeguroPipe } from '../pipes/dom-seguro.pipe';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ChatConversationComponent } from 'src/app/components/chat-conversation/chat-conversation.component';
import { ChatListComponent } from 'src/app/components/chat-list/chat-list.component';
import { RescheeduleDialogComponent } from './rescheedule-dialog/rescheedule-dialog.component';
import { ReportDialogComponent } from './report-dialog/report-dialog.component';
import { ShowInfoStudentsDialogComponent } from './show-info-students-dialog/show-info-students-dialog.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { InfoDialogComponent } from './info-dialog/info-dialog.component';
import { HoursPackDialogComponent } from './hours-pack/hours-pack-dialog.component';
import { GrupalPaymentModalComponent } from './grupal-payment-modal/grupal-payment-modal.component';
// import { CalendarWeekAvailability } from './calendar-week-availability/calendar-week-availability.component'

FullCalendarModule.registerPlugins([
  // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin,
  timeGridPlugin,
]);

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    CustomSnackBarComponent,
    NameFilePipe,
    CheckHeightPipe,
    CheckOptionDisabledTeacherSubjectLevelPipe,
    CheckStudyLessonTeacherIsLanguagePipe,
    VarDirective,
    ErrorImageDirective,
    LazyLoadDirective,
    SidenavComponent,
    LoadingComponent,
    AutocompleteComponent,
    Autocomplete2Component,
    BookingCalendarComponent,
    SelectFilterableComponent,
    AgendaDialogComponent,
    JitsiComponent,
    PaymentDialogComponent,
    BookingDialogComponent,
    ConfirmDialogComponent,
    TeacherImageAdvicesDialogComponent,
    checkUserCanConfirmClassPipe,
    DomSeguroPipe,
    StarRatingComponent,
    ChatConversationComponent,
    ChatListComponent,
    RescheeduleDialogComponent,
    ReportDialogComponent,
    ShowInfoStudentsDialogComponent,
    InfoDialogComponent,
    HoursPackDialogComponent,
    GrupalPaymentModalComponent,
    // CalendarWeekAvailability
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatDividerModule,
    NgxMaterialTimepickerModule,
    MatProgressSpinnerModule,
    FullCalendarModule,
    RouterModule,
    MatSidenavModule,
    MatMenuModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatRadioModule,
    MatTableModule,
    MatChipsModule,
    MatButtonToggleModule,
    MatExpansionModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    AutocompleteComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatDividerModule,
    NgxMaterialTimepickerModule,
    MatProgressSpinnerModule,
    NameFilePipe,
    CheckHeightPipe,
    CheckOptionDisabledTeacherSubjectLevelPipe,
    CheckStudyLessonTeacherIsLanguagePipe,
    VarDirective,
    ErrorImageDirective,
    LazyLoadDirective,
    MatSidenavModule,
    FullCalendarModule,
    SidenavComponent,
    LoadingComponent,
    MatMenuModule,
    AutocompleteComponent,
    MatCheckboxModule,
    Autocomplete2Component,
    NgxMatSelectSearchModule,
    MatPaginatorModule,
    MatTooltipModule,
    BookingCalendarComponent,
    SelectFilterableComponent,
    AgendaDialogComponent,
    JitsiComponent,
    PaymentDialogComponent,
    BookingDialogComponent,
    TeacherImageAdvicesDialogComponent,
    MatRadioModule,
    MatTableModule,
    MatChipsModule,
    checkUserCanConfirmClassPipe,
    DomSeguroPipe,
    StarRatingComponent,
    MatButtonToggleModule,
    ChatConversationComponent,
    ChatListComponent,
    InfoDialogComponent,
    RescheeduleDialogComponent,
    ReportDialogComponent,
    ShowInfoStudentsDialogComponent,
    MatExpansionModule,
    HoursPackDialogComponent,
    // CalendarWeekAvailability
  ],
})
export class ComponentsModule { }
